/* LA CONECTA — cart UI glue for the custom lc-header.
 *
 * Horizon dispatches `shopify:cart:lines-update` for every cart mutation
 * (add / remove / update — see assets/standard-events.d.ts); the event's
 * `promise` resolves with the fresh cart. Three jobs here:
 *   1. keep every [data-lc-cart-count] in sync — lc-header renders the
 *      count with Liquid, so it goes stale after any AJAX cart change,
 *   2. pop the "added to cart" toast on successful adds,
 *   3. make the lc-header cart links open the theme's cart drawer instead
 *      of navigating. The drawer isn't rendered on the /cart template
 *      (see snippets/cart-drawer.liquid), so the links keep their href as
 *      a natural fallback there.
 */
(function () {
  var CART_LINES_UPDATE = 'shopify:cart:lines-update';

  function updateCounts(count) {
    if (typeof count !== 'number' || Number.isNaN(count)) return;
    document.querySelectorAll('[data-lc-cart-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  /* ---- Toast ---------------------------------------------------------- */

  var toast = document.getElementById('lc-cart-toast');
  var toastTimer = null;
  var addedSinceShown = 0;

  function hideToast() {
    if (!toast) return;
    clearTimeout(toastTimer);
    toastTimer = null;
    addedSinceShown = 0;
    toast.classList.remove('lc-cart-toast--show');
  }

  function armToastTimer() {
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4000);
  }

  function showToast(quantityAdded) {
    if (!toast) return;

    addedSinceShown += quantityAdded || 1;
    var qty = toast.querySelector('.lc-cart-toast__qty');
    if (qty) {
      qty.textContent = '× ' + addedSinceShown;
      qty.toggleAttribute('hidden', addedSinceShown < 2);
    }

    // Re-trigger the entrance + progress animations on repeat adds.
    toast.classList.remove('lc-cart-toast--show');
    void toast.offsetWidth;
    toast.classList.add('lc-cart-toast--show');
    armToastTimer();
  }

  if (toast) {
    // Hovering pauses the countdown (progress bar pauses via CSS).
    toast.addEventListener('mouseenter', function () {
      clearTimeout(toastTimer);
      toastTimer = null;
    });
    toast.addEventListener('mouseleave', armToastTimer);
  }

  /* ---- Cart drawer ------------------------------------------------------ */

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return false;
    hideToast();
    customElements.whenDefined('theme-drawer').then(function () {
      if (typeof drawer.open === 'function') drawer.open();
    });
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.lc-nav__cart, .lc-drawer__cart, .lc-cart-toast__cta');
    if (!link) return;
    // No drawer on this page (e.g. /cart template): let the link navigate.
    if (!document.getElementById('cart-drawer')) return;
    event.preventDefault();
    openCartDrawer();
  });

  /* ---- Cart mutations --------------------------------------------------- */

  document.addEventListener(CART_LINES_UPDATE, function (event) {
    var isAdd = event.action === 'add';
    var quantityAdded = 0;
    if (isAdd && Array.isArray(event.lines)) {
      quantityAdded = event.lines.reduce(function (sum, line) {
        return sum + (line.quantity || 0);
      }, 0);
    }

    if (!event.promise) return;
    event.promise
      .then(function (result) {
        var cart = result && result.cart;
        var failed =
          !cart ||
          (result.userErrors && result.userErrors.length > 0) ||
          (result.detail && result.detail.didError);

        if (cart) updateCounts(cart.totalQuantity);
        if (isAdd && !failed) showToast(quantityAdded);
      })
      .catch(function (error) {
        if (error && error.name !== 'AbortError') {
          console.warn('[lc-cart-ui] cart update promise rejected:', error);
        }
      });
  });

  // Back/forward cache restores show the count that was baked into the
  // cached HTML — re-fetch the real one (same concern cart-icon.js covers
  // for the standard header).
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCounts(cart.item_count);
      })
      .catch(function () {
        /* offline restore — keep the cached count */
      });
  });
})();
